import { Loader as UiLoader } from '@vinted/web-ui'

const Loader = () => (
  <div className="c-input__icon">
    <UiLoader />
  </div>
)

export default Loader
